import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { toast } from "sonner";

/**
 * Hook to update a rejected expense (resubmit).
 * Invalidates the expense queries on success.
 */
export function useUpdateExpense() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.expense.updateExpense.mutationOptions(),
    onSuccess: () => {
      // Invalidate expense queries to refetch
      queryClient.invalidateQueries({
        queryKey: trpc.expense.getMyExpenses.queryKey(),
      });
      // Also invalidate org pending expenses view
      queryClient.invalidateQueries({
        queryKey: trpc.expense.getPendingExpensesForOrg.queryKey(),
      });
      toast.success("Expense resubmitted successfully");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to update expense");
    },
  });

  return mutation;
}
